"use strict";

angular.module('app.api', [
    'app.api.errorHandling',
    'app.api.config'
]);